import classNames from 'classnames';
import { FC, HTMLAttributes, type JSX } from 'react';

import { InformerProps, Informer, ConditionView } from '@/shared/ui';

import './BaseCard.scss';

interface BaseCardProps extends HTMLAttributes<HTMLDivElement> {
  header: JSX.Element;
  body: JSX.Element;
  informer?: Nullable<InformerProps>;
  accordion?: Nullable<JSX.Element>;
  actions?: JSX.Element[];
}

export const BaseCard: FC<BaseCardProps> = ({
  className,
  header,
  body,
  informer,
  accordion,
  actions = [],
  ...restProps
}) => {
  const activeActions = actions
    .filter((element) => {
      if (!element) return false;
      if ('if' in element.props && !element.props.if) return false;
      return true;
    })
    .map((ActionElement) => {
      const key = ActionElement.key;
      return (
        <div key={key} className="service-row-card__action-wrapper">
          {ActionElement}
        </div>
      );
    });

  return (
    <div {...restProps} className={classNames('custom-base-card', className)}>
      <div className="custom-base-card__header">{header}</div>
      <div className="custom-base-card__body">{body}</div>
      <ConditionView if={Boolean(informer)}>
        <div className="custom-base-card__informer">
          {informer && <Informer className="service-row-card__informer" {...informer} />}
        </div>
      </ConditionView>
      <ConditionView if={Boolean(accordion)}>
        <div className="custom-base-card__accordion">{accordion}</div>
      </ConditionView>
      <ConditionView if={activeActions.length > 0}>
        <div className="custom-base-card__actions">{activeActions}</div>
      </ConditionView>
    </div>
  );
};
